export default "/assets/8b1e993c123ba1c3.svg"